import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { PageHero } from '../components/layout/PageHero';
import { EcosystemCard } from '../components/ecosystem/EcosystemCard';
import { ecosystemEntries } from '../data/ecosystem';
import { fadeUp } from '../utils/motion';
export function EcosystemPage() {
  return <>
      <PageHero eyebrow="Ecosystem" title="Connected technology. Shared ambition." lead="Explore the organizations and initiatives bringing SyNeural’s technology into research, human development and institutional coordination." data-id="element-3000" data-mp="76a710cod9cc" />

      <section aria-label="Ecosystem directory" className="bg-surface-bg py-20 lg:py-28" data-id="element-3001" data-mp="lyc5cfz3jua9">
        <motion.ul {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-3002" data-mp="qvc7wgwqmewm">
          {ecosystemEntries.map(entry => <li key={entry.slug} data-id="element-3003" data-mp="zwisb12ic9v5">
              <EcosystemCard entry={entry} headingLevel="h2" data-id="element-3004" data-mp="zxtwh1zv7jms" />
            </li>)}
        </motion.ul>
      </section>

      <section aria-labelledby="build-title" className="bg-navy-deep text-white py-20 lg:py-28" data-id="element-3005" data-mp="18rzi0y4at22o">
        <motion.div {...fadeUp} className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3006" data-mp="14ulbxfbwzaew">
          <h2 id="build-title" className="font-heading font-bold text-4xl lg:text-5xl tracking-tight mb-6" data-id="element-3007" data-mp="zvi63so4105v">
            Build with SyNeural.
          </h2>
          <p className="text-xl text-white/80 leading-relaxed mb-10" data-id="element-3008" data-mp="1sicpem96xthr">
            Explore a partnership or implementation around the knowledge, people and workflows your organization needs
            to connect.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center" data-id="element-3009" data-mp="1iqp4733898oq">
            <a href="/partnerships" className="inline-flex items-center justify-center gap-2 bg-white text-navy hover:bg-surface-muted font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-3010" data-mp="1dsducscxmy6i">
              Discuss a partnership <ArrowRight size={18} aria-hidden="true" data-id="element-3011" data-mp="8kufub9cfvm4" />
            </a>
            <a href="/contact" className="inline-flex items-center justify-center border border-white/40 text-white hover:bg-white/10 font-semibold px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-3012" data-mp="3r0es0v3z1s4u">
              Contact SyNeural
            </a>
          </div>
        </motion.div>
      </section>
    </>;
}